import axios from 'axios'
import queryString from '../query-string'
import config from '../../config'
import store from '../../store'
import i18n from '../../i18n'
import requestInterceptors from './interceptors/request/browser'
import responseInterceptors from './interceptors/response/browser'
import { getToken } from '@/utils/useStore'
import { Message } from 'element-ui'
const [requestResolve, requestReject] = requestInterceptors
const [responseResolve, responseReject] = responseInterceptors

const _setupInterceptors = (axios) => {
  // setup interceptor for request
  axios.interceptors.request.use(requestResolve, requestReject)
  // setup interceptor for response
  axios.interceptors.response.use(responseResolve, responseReject)
}

/**
 * 2021-3-26：新增isComplete字段 boolean
 * @param {*} type
 * @param {*} isComplete 用于表示type是否已为完整的baseurl
 */
let createRequest = (type, isComplete = false) => {
  // 判断网络
  if(!window.navigator.onLine){
    Message.closeAll()
    Message({
      type: 'error',
      message: i18n.t('im_audio_load_failed'),
      onClose: () => {
        console.log("offine");
      }
    })
  }
  // 退出登录后，store中的api都被清除，因此当从api中取不到数据时，需要去default中取
  let baseURL
  if (isComplete) {
    baseURL = type
  } else {
    let user_info = store.state.user.user_info || {}
    let info_api = user_info.APIList
      ? user_info.APIList[type] && user_info.APIList[type].length > 0
        ? user_info.APIList[type][0]
        : null
      : null
    baseURL =
      info_api ||
      (config.api && config.api[type]
        ? config.api[type]
        : config.api_default[type])
  }
  // let baseURL = (config.api && config.api[type]) ? config.api[type] : config.api_default[type]
  const clientRequest = axios.create({
    // baseURL: config.api[type],
    baseURL,
    paramsSerializer: function (params) {
      const token = getToken() || params.token || ''
      params.a_timeStamp = `${Date.now()}_${__GLOBAL__.version}`
      if(token && (token != undefined || token != 'undefined') ) {
        params.token = token
      }
      return queryString.stringify(params)
    },
    transformRequest: [
      function (data, headers) {
        if (data instanceof Blob) {
          return data
        }
        let contentType = headers['Content-Type']

        if (contentType == 'application/x-www-form-urlencoded') {
          headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
          headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
          data.a_timeStamp = `${Date.now()}_${__GLOBAL__.version}`
          let ret = ''
          for (let key in data) {
            if (data[key] != undefined && data[key] != null) {
              ret +=
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(data[key]) +
                '&'
            }
          }
          ret = ret.substring(0, ret.length - 1)
          return ret
        } else {
          headers.post['Content-Type'] = 'application/json;charset=UTF-8'
          headers.get['Content-Type'] = 'application/json;charset=UTF-8'
          return JSON.stringify(data)
        }
      }
    ]
    // transformRequest: [
    //   function(data, headers) {
    //     if (data instanceof Blob) {
    //       return data
    //     }
    //     headers.post['Content-Type'] = 'text/plain;charset=UTF-8'
    //     return JSON.stringify(data)
    //   }
    // ]
  })
  _setupInterceptors(clientRequest)

  return clientRequest
}

_setupInterceptors(axios)

export default createRequest
